import apiClient from "./client.js";

/**
 * Fetch all maintenance windows for the active workspace.
 * @returns {{ data: Array, error: null, meta: {} }}
 */
export async function fetchMaintenanceWindows() {
  const res = await apiClient.get("/maintenance-windows");
  return res.data.data;
}

/**
 * Create a new maintenance window.
 * @param {{ name: string, comment?: string, starts_at: string, ends_at: string, monitor_ids: string[] }} data
 */
export async function createMaintenanceWindow(data) {
  const res = await apiClient.post("/maintenance-windows", data);
  return res.data.data;
}

/**
 * Fetch a single maintenance window by ID.
 * @param {string} id
 */
export async function fetchMaintenanceWindow(id) {
  const res = await apiClient.get(`/maintenance-windows/${id}`);
  return res.data.data;
}

/**
 * Partially update a maintenance window.
 * @param {string} id
 * @param {Partial<{ name: string, comment: string, starts_at: string, ends_at: string, monitor_ids: string[] }>} data
 */
export async function updateMaintenanceWindow(id, data) {
  const res = await apiClient.patch(`/maintenance-windows/${id}`, data);
  return res.data.data;
}

/**
 * Delete a maintenance window.
 * @param {string} id
 */
export async function deleteMaintenanceWindow(id) {
  await apiClient.delete(`/maintenance-windows/${id}`);
}
